<template>
    <div class="sku-component">
        <!-- <p>商品多规格选择示例</p>
        <el-button @click="getSkuId">获取</el-button> -->
        <div v-for="(item, index) in specList" :key="index"
             class="sku-item">
            <p>{{ item.title }}：</p>
            <div class="sku-box-area">
                <template v-for="item2 in item.list">
                    <div
                        :key="item2.id"
                        :class="{
                            'sku-box': true,
                            'sku-text': true,
                            'active': isActive(item2),
                            'disabled': !isOption(item2),
                        }"
                        @click="
                            handleClick(isOption(item2), item2, index)
                        ">
                        {{ item2.value }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'SkuSelector',
    data() {
        return {
            specList: [],
            specCombinationList: [],
            specsS: [], // 选中的数据
            adjoinArray: [],
            char: '#'
        }
    },
    computed: {
        optionSpecs() {
            return this.getSpecOptions(this.specsS)
        },
        vertex() {
            return this.specList.reduce( (total, current) => [...total, ...current.list], [] )
        },
        len() {
            return this.vertex.length
        },
    },
    props: {
        goodsData: Array
    },
    watch: {
        goodsData: {
            handler: function() {
                // console.log('this.goodsData',this.goodsData);
                this.dataConversion(this.goodsData)
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        // let res = {"code":"00000","desc":"执行成功","data":{"id":"52774","goodsType":1091,"name":"LANJU/榄菊 无香无味杀虫气雾剂 2147483647 300mL 1瓶 销售单位：瓶","kind":2,"originalPrice":null,"currentPrice":null,"homePicture":"http://pathfinder-private.oss-cn-shanghai.aliyuncs.com/PRODUCT/BIG/BIG_AE1470828_01.jpg?x-oss-process=style/common_style","detailPictures":["http://pathfinder-private.oss-cn-shanghai.aliyuncs.com/PRODUCT/BIG/BIG_AE1470828_01.jpg?x-oss-process=style/common_style"],"orderringInformation":null,"effectiveTime":null,"stock":null,"isPurchaseRestriction":0,"isPossibletoRefund":7,"isUseCoupon":1,"detailInformation":"<!DOCTYPE html><html lang='en'><head><meta http-equiv='Content-Type' content='text/html; charset=UTF-8'><meta http-equiv='x-ua-compatible' content='IE=edge'><title>震坤行采购服务平台 - 全国领先的MRO工业用品一站式采购服务平台</title><!-- title_icon --><meta http-equiv='pragma' content='no-cache'> <meta http-equiv='Cache-Control' content='no-cache, must-revalidate'> <meta http-equiv='expires' content='0'><!-- 通用的css样式放在这里，自定义的放在自己用到的地方 --><link rel='stylesheet' type='text/css' href='https://zkh-esp-public.oss-cn-hangzhou.aliyuncs.com/Webshop/images/product_detail.css'></head><body><div><!-- 详细信息 start --><div class='detailed_info' id='zkh_cp_detail_info'><div class='detail_content clearfix' id='advantage'><div class='left_imgs'><div id='href01'><h5><div><span>产品介绍&nbsp;/&nbsp;<i>Introduction</i><em class='triangle01'></em></span></div><em class='slogan'></em><em class='triangle02'></em></h5><h6>商品属性：</h6><div class='goods_feature_box'><span class='goods_feature'><label>净含量:</label>300mL</span><span class='goods_feature'><label>销售单位:</label>瓶</span><span class='goods_feature'><label>品牌:</label>LANJU/榄菊</span><span class='goods_feature'><label>产品名称:</label>无香无味杀虫气雾剂</span><span class='goods_feature'><label>制造商型号:</label>2147483647</span><span class='goods_feature'><label>箱规:</label>24瓶/箱</span><span class='goods_feature'><label>核心规格:</label>300mL</span></div><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/BIG/BIG_AE1470828_01.jpg?x-oss-process=style/common_style'></div><div id='href08'><h5><div><span>产品概要&nbsp;/&nbsp;<i>Outline</i><em class='triangle01'></em></span></div><em class='slogan'></em><em class='triangle02'></em></h5><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_02.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_03.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_04.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_05.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_06.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_07.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_08.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_09.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_10.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_11.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_12.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_13.jpg?x-oss-process=style/common_style'><img  src='http://pathfinder-private.oss-cn-shanghai.aliyuncs.com//PRODUCT/PRO/PRO_AE1470828_14.jpg?x-oss-process=style/common_style'></div></div></div><!-- 公司服务信息start --><div class='company_ads' id='contact_us' style='box-sizing: border-box;'><table><tbody><tr><th style='width: 44px;'><img src='https://esp-image.zkh360.com/Webshop/images/icon01.png?x-oss-process=style/common_style'></th><td><h5>关于震坤行</h5><p>震坤行（zkh360)----全称为震坤行工业超市。是一个专业铸就自信、着眼长远发展、并且乐于承担社会责任的团队，竭诚期待与您的合作！</p></td></tr><tr><th><img src='https://esp-image.zkh360.com/Webshop/images/icon02.png?x-oss-process=style/common_style'></th><td><h5>正品保证</h5><p>震坤行工业超市向您保证所售商品均为正品行货，开具正规发票。</p></td></tr><tr><th><img src='https://esp-image.zkh360.com/Webshop/images/icon03.png?x-oss-process=style/common_style'></th><td><h5>全场免运费</h5><p>自 2014 年8月25日起，我司实行全线免运费的运输收费标准，不论普货或危险品，不论购买数量和金额，皆可享受我司的免费配送服务。</p></td></tr><tr><th><img src='https://esp-image.zkh360.com/Webshop/images/icon04.png?x-oss-process=style/common_style'></th><td><h5>退换货无忧</h5><p>凭质保证书及震坤行发票，可享受全国联保服务，与您亲临商场选购的商品享受相同的质量保证。如有任何问题均可安全退换货物，请您放心购买！</p></td></tr></tbody></table></div><!-- 公司服务信息end --></div></div></body></html>","goodsSn":null,"initialPurchaseNums":1,"brandId":4247,"sourceType":2,"giveRefundType":0,"isSetArea":0,"areaType":null,"areaContent":null,"brand":null,"expressFeeTemplate":null,"productSkuStock":[{"id":81417,"skuCode":null,"price":14.78,"stock":0,"pic":"http://pathfinder-private.oss-cn-shanghai.aliyuncs.com/PRODUCT/BIG/BIG_AE1470828_01.jpg?x-oss-process=style/common_style","marketPrice":14.90,"initialPurchaseNums":24,"sourceId":"AE1470828","externalGoodsId":null,"productSpecValues":[{"valueId":null,"productSkuStockId":"81417","valueName":"净含量","value":"300mL"},{"valueId":null,"productSkuStockId":"81417","valueName":"销售单位","value":"瓶"},{"valueId":null,"productSkuStockId":"81417","valueName":"品牌","value":"LANJU/榄菊"},{"valueId":null,"productSkuStockId":"81417","valueName":"产品名称","value":"无香无味杀虫气雾剂"},{"valueId":null,"productSkuStockId":"81417","valueName":"制造商型号","value":"2147483647"},{"valueId":null,"productSkuStockId":"81417","valueName":"箱规","value":"24瓶/箱"},{"valueId":null,"productSkuStockId":"81417","valueName":"核心规格","value":"300mL"}],"isInventoryVO":{"code":"0000","stock":500,"skuId":null,"desc":"有货"}}],"minValueId":81417,"goodsLevel":{"level3":1091,"level3Name":"震坤行分类","level2":1090,"level2Name":"震坤行","level1":1015,"level1Name":"集采"}},"success":true}
        // let res = {"code":"00000","desc":"执行成功","data":{"id":"29262","goodsType":405,"name":"物品","kind":2,"originalPrice":11122,"currentPrice":1778,"homePicture":"https://zh-mall.obs.cn-north-4.myhuaweicloud.com:443/yjweb/images/e5c788957c944d00a6d41a8b117c5bc6.jpg","detailPictures":["https://zh-mall.obs.cn-north-4.myhuaweicloud.com:443/yjweb/images/d4eaf844f81045d999101ded97ead2e5.jpg;"],"orderringInformation":null,"effectiveTime":"2023-02-21 11:47:02","stock":247,"isPurchaseRestriction":0,"isPossibletoRefund":7,"isUseCoupon":1,"detailInformation":"<p><br></p>","goodsSn":null,"initialPurchaseNums":1,"brandId":30,"sourceType":0,"giveRefundType":0,"isSetArea":0,"areaType":null,"areaContent":null,"brand":null,"expressFeeTemplate":null,"productSkuStock":[{"id":28699,"skuCode":null,"price":17.78,"stock":0,"pic":"https://zh-mall.obs.cn-north-4.myhuaweicloud.com:443/yjweb/images/45ce17f7fa094d73b5f50b786bf20396.jpg","marketPrice":177.95,"initialPurchaseNums":1,"sourceId":null,"externalGoodsId":null,"productSpecValues":[{"valueId":null,"productSkuStockId":"28699","valueName":"颜色","value":"红色"},{"valueId":null,"productSkuStockId":"28699","valueName":"尺寸","value":"35"}],"isInventoryVO":null},{"id":28700,"skuCode":null,"price":35555.55,"stock":60,"pic":"https://zh-mall.obs.cn-north-4.myhuaweicloud.com:443/yjweb/images/130cab98120c492ab4826b75135b6da8.jpg","marketPrice":177.95,"initialPurchaseNums":1,"sourceId":null,"externalGoodsId":null,"productSpecValues":[{"valueId":null,"productSkuStockId":"28700","valueName":"颜色","value":"红色"},{"valueId":null,"productSkuStockId":"28700","valueName":"尺寸","value":"36"}],"isInventoryVO":null},{"id":28701,"skuCode":null,"price":1600000.00,"stock":70,"pic":"https://zh-mall.obs.cn-north-4.myhuaweicloud.com:443/yjweb/images/cb988278c3a44b0ebd3aaf865dc52ec6.jpg","marketPrice":177.95,"initialPurchaseNums":1,"sourceId":null,"externalGoodsId":null,"productSpecValues":[{"valueId":null,"productSkuStockId":"28701","valueName":"颜色","value":"黑色"},{"valueId":null,"productSkuStockId":"28701","valueName":"尺寸","value":"35"}],"isInventoryVO":null},{"id":28702,"skuCode":null,"price":1600000.00,"stock":79,"pic":"https://zh-mall.obs.cn-north-4.myhuaweicloud.com:443/yjweb/images/a7b69806f4cd48ae8e0f555531d91b8b.jpg","marketPrice":177.95,"initialPurchaseNums":1,"sourceId":null,"externalGoodsId":null,"productSpecValues":[{"valueId":null,"productSkuStockId":"28702","valueName":"颜色","value":"黑色"},{"valueId":null,"productSkuStockId":"28702","valueName":"尺寸","value":"36"}],"isInventoryVO":null}],"minValueId":28699,"goodsLevel":{"level3":405,"level3Name":"家居电器","level2":40,"level2Name":"生活家电","level1":4,"level1Name":"数码家电"}},"success":true}
        // console.log(res.data);
        // this.dataConversion(res.data.productSkuStock)
    },
    methods: {
        getSkuId() {
            console.log(this.specsS);
            return this.specS['skuId']
        },
        // 数据处理
        dataConversion(data) {
            let valueName = []
            let value = {}
            let properties = []
            let skuList = []
            data.forEach( item => {
                let skuListObj = { id: item.id, price: item.price, stock: item.stock, specs: [], str: '' }
                let str = []
                let specs = []
                item.productSpecValues.forEach( val => {
                    if(!valueName.includes(val.valueName)) {
                        valueName.push(val.valueName)
                        value[val.valueName] = []
                    }
                    if(val.value) {
                        // console.log(value[val.valueName],val.value, !value[val.valueName].includes(val.value));
                        if(!value[val.valueName].includes(val.value)){
                            value[val.valueName].push(val.value)
                        }
                        if(!specs.includes(val.valueName)) {
                            specs.push(val.valueName)
                            str.push(val.value)
                            skuListObj.specs.push({ value: val.valueName, id: val.value + this.char + val.valueName})
                        }
                    }
                })
                // if(item.stock > 0 || item.isInventoryVO != null){ // 库存
                    skuListObj.str = str.join(this.char)
                    skuList.push(skuListObj)
                // }
            })
            properties = valueName.map( key => ({
                title: key,
                list: value[key].map( item => ({ value: item, id: item + this.char + key }))
            }))
            console.log('valueName',valueName);
            console.log('value',value);
            console.log('properties',properties);
            console.log('skuList',skuList);
            this.specList = properties.filter(item => item.list.length > 0)
            this.specCombinationList = skuList
            this.init()
            if(skuList.length == 1){
                this.defaultSelect()
            }
        },
        // 默认选中 最小价格商品
        async defaultSelect() {
            let minPrice = Math.min(...this.goodsData.map(item => item.price))
            let minItem = this.specCombinationList.find(item => item.price == minPrice).specs.map(item => item.id)
            for (let i = 0; i < this.specList.length; i++) {
                for (let j = 0; j < this.specList[i].list.length; j++) {
                    let is = this.isOption(this.specList[i].list[j])
                    if(is && is.id && minItem.includes(is.id)) {
                        this.handleClick(is, this.specList[i].list[j], i)
                        break;
                    }
                }
            }
        },
        isActive(val) {
            return this.specsS.find((item) => item && item.id === val.id)
        },
        isOption(val) {
            // console.log('isOption',this.optionSpecs,val);
            return this.optionSpecs.find((item) => item.id === val.id)
        },
        init() {
            this.adjoinArray = Array(this.len * this.len).fill(0)
            this.specsS = Array(this.specList.length).fill(null)
            // console.log(this.specsS)
            this.initSpec()
            // console.log(this.adjoinArray)
            this.initSameLevel()
            // console.log(this.adjoinArray)
        },
        initSpec() {
            this.specCombinationList.forEach((item) =>
                this.fillInSpec(item.specs)
            )
        },
        initSameLevel() {
            this.specList.forEach((item) => {
                const params = []
                // 获取同级别顶点
                item.list.forEach((val) => {
                    if (this.optionSpecs.includes(val)) params.push(val)
                })
                // 同级点位创建
                this.fillInSpec(params)
            })
        },
        fillInSpec(params) {
            params.forEach((param) => {
                this.setAdjoinVertexs(param, params)
            })
        },
        setAdjoinVertexs(side, sides) {
            let pIndex = ''
            for (let i = 0; i < this.vertex.length; i += 1) {
                if (side.id === this.vertex[i].id) {
                    pIndex = i
                    break
                }
            }
            sides.forEach((item) => {
                let index = ''
                for (let i = 0; i < this.vertex.length; i += 1) {
                    if (item.id === this.vertex[i].id) {
                        index = i
                        break
                    }
                }
                this.adjoinArray[pIndex * this.len + index] = 1
            })
        },
        getVertexCol(param) {
            let idx = ''
            for (let i = 0; i < this.vertex.length; i += 1) {
                if (param.id === this.vertex[i].id) {
                    idx = i
                    break
                }
            }
            const col = []
            this.vertex.forEach((item, pIndex) => {
                col.push(this.adjoinArray[idx + this.len * pIndex])
            })
            return col
        },
        getColSum(params) {
            const paramsVertex = params.map((param) => this.getVertexCol(param))
            const paramsVertexSum = []
            this.vertex.forEach((item, index) => {
                const rowTotal = paramsVertex
                    .map((value) => value[index])
                    .reduce((total, current) => {
                        let newTotal = total
                        newTotal += current || 0
                        return newTotal
                    }, 0)
                paramsVertexSum.push(rowTotal)
            })
            return paramsVertexSum
        },
        getUnion(params) {
            const paramsColSum = this.getColSum(params)
            const union = []
            paramsColSum.forEach((item, index) => {
                if (item && this.vertex[index]) union.push(this.vertex[index])
            })
            return union
        },
        getIntersection(params) {
            const paramsColSum = this.getColSum(params)
            const intersection = []
            paramsColSum.forEach((item, index) => {
                if (item >= params.length && this.vertex[index])
                    intersection.push(this.vertex[index])
            })
            return intersection
        },
        getSpecOptions(params) {
            let specOptionCanChoose = []
            if (params.some(Boolean)) {
                specOptionCanChoose = this.getIntersection(
                    params.filter(Boolean)
                )
            } else {
                specOptionCanChoose = this.getUnion(this.vertex)
            }
            return specOptionCanChoose
        },
        // 点击选择sku
        handleClick(bool, item, idx) {
            // 排除可选规格里面没有的规格
            if (!bool) return
            // 根据text判断是否已经被选中了，如果已选则取消选中
            // console.log(this.specsS[idx]);
            if (!this.specsS[idx]) {
                this.$set(this.specsS, idx, item)
            } else {
                this.$set(
                    this.specsS,
                    idx,
                    this.specsS[idx].id === item.id ? null : item
                )
            }
            if(this.specsS.every( s => s !== null )){
                this.$set(this.specsS, 'skuId', this.setSkuId())
            } else {
                this.$set(this.specsS, 'skuId', '')
            }
            this.$nextTick(() => {
                this.$emit('change', this.specsS)
            })
        },
        setSkuId() {
            let join = this.specsS.map(item => item.value).join(this.char)
            let spec = this.specCombinationList.find( item => item.str == join)
            // console.log(join,spec);
            return spec ? spec.id : ''
        },
    },
}
</script>

<style lang="scss" scoped>
.sku-component {
    width: 100%;
    // padding: 24px;

    .sku-item {
        display: flex;
        margin-bottom: 21px;

        p {
            flex-shrink: 0;
            margin: 0;
        }

        .sku-box-area {
            display: flex;
            flex: 1;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 10px;
            width: 85%;
        }
        .sku-box {
            width: auto;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #e5e5e5;
            // margin: -1px 12px 10px 0px;
            padding: 8px 10px;
            box-sizing: border-box;
            cursor: pointer;
            // overflow: hidden;
            position: relative;

            &:hover {
                border-color: red;
            }
        }
        .sku-text {
            font-size: 14px;
            color: #000;
        }
        .active {
            border-color: red;
            // color: red;
            &::before {
                content: "";
                position: absolute;
                top: -1px;
                left: -1px;
                width: 0;
                height: 0;
                padding: 0;
                border-top: 12px solid #f2270c;
                border-left: 12px solid #f2270c;
                border-right: 12px solid transparent;
                border-bottom: 12px solid transparent;
            }
            &::after {
                content: '';
                background: transparent;
                width: 8px;
                height: 4px;
                border-left: 2px solid #fff;
                border-bottom: 2px solid #fff;
                position: absolute;
                top: 6px;
                left: 18px;
                position: absolute;
                top: 2px;
                left: 2px;
                transform: rotate(315deg);
            }
        }
        .disabled {
            opacity: 0.5;
            border-color: #e0e0e0;
            color: #999999;
            background-color: #eee;
        }
    }
}
</style>
